import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../MainDash/Alerts/AlertInfoPage.css';
import '../MainDash/Alerts/AlertPage.css';
import '../MainDash/NewHome.css';
import '../MainDash/Alerts/AssignAlert.css';
import { IconButton, Button, InputAdornment, TextField } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const Refer = () => {
    const history = useHistory();

    const referralUrl = "https://mybuildingalerts.com/referral?code=YOUR_CODE";
    const [copied, setCopied] = useState(false);
    
    const handleCopy = () => {
        navigator.clipboard.writeText(referralUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleEmail = () => {
        window.location.href = `mailto:?subject=Join MyBuildingAlerts&body=Sign up and get 1 month free: ${referralUrl}`;
    };
    
    return (
        <div className='FeedbackPage'>
            <div className='alerts-section'>
                <div className="alerts-header">
                    <div className="title-container">
                        <IconButton onClick={() => history.push('/Home')}>
                            <ArrowBackIosNewIcon
                                className="z-0"
                                style={{ color: 'rgb(14, 81, 46)' }}
                            />
                        </IconButton>
                        <h2 className='input-header'>Refer</h2>
                        <div className="placeholder" style={{ width: '40px', backgroundColor: 'transparent' }}></div>
                    </div>
                </div>
                <div className='refer-content'>
                    <p>Refer other building owners and earn <span className='refer-span'>1 month FREE </span>
                    for each referral that signs up for MyBuildingAlerts.</p> 
                    <p>New building owners will also receive <span className='refer-span'>1 month FREE </span>
                    upon joining MyBuildingAlerts.</p>
                </div>
                <div className='refer-url-section'>
                    <p style={{margin: 0}}>Copy and share your custom URL:</p>
                    <TextField 
                        value={referralUrl} 
                        fullWidth 
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleCopy} edge="end">
                                        <ContentCopyIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    {copied && <p className='copied-text'>Copied!</p>}
                    <div className='refer-buttons'>
                        <Button variant='contained' onClick={() => window.location.href = `mailto:?subject=Join MyBuildingAlerts!&body=Sign up using this link: ${referralUrl}`}>
                            Email
                        </Button>
                        <Button variant='outlined'
                                onClick={() => {
                                    if (navigator.share) {
                                        navigator.share({
                                            title: 'Join MyBuildingAlerts!',
                                            text: 'Sign up using this link:',
                                            url: referralUrl
                                        }).catch((error) => console.log('Error sharing:', error));
                                    } else {
                                        alert('Sharing is not supported on this browser.');
                                    }
                                }}
                            >
                            Share
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Refer;